export default __webpack_public_path__ + "static/media/art-4-main-md.f2f1854e.jpg";